import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import * as Account from "../account";

export default function RequireAuth({ children }) {
  const location = useLocation();
  const account = Account.getUserAccount();

  if (!account) {
    const next = encodeURIComponent(
      `${location.pathname}${location.search}${location.hash}`
    );
    return <Navigate to={`/signin?next=${next}`} replace />;
  }

  return children;
}
